import { render } from "./audits.vue?vue&type=template&id=4a73d4ac"
import script from "./audits.vue?vue&type=script&lang=ts"
export * from "./audits.vue?vue&type=script&lang=ts"
script.render = render

export default script